module.exports = __webpack_public_path__ + "media/variables.e208b8d7.mp4";